import MarketingNav from './MarketingNav';
import MarketingFooter from './MarketingFooter';

const scribeFeatures = [
  'SOAP notes generated automatically from consultations',
  'Referral letters drafted in seconds',
  'Discharge summaries with a single click',
  'Real-time transcription with clinical vocabulary',
  'Supports audio recording from any device',
  'Reviewed and edited by the clinician before finalising',
];

const opsFeatures = [
  'Patient scheduling and appointment management',
  'Bed management and occupancy tracking',
  'Pharmacy and medication management',
  'Supply chain and inventory monitoring',
  'Multi-facility dashboard for administrators',
  'Role-based access control for your entire team',
];

export default function MarketingFeatures() {
  return (
    <div className="bg-[#F0F9FF] min-h-screen flex flex-col">
      <MarketingNav />

      <section className="bg-[#0A2540] text-white py-16 px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold mb-4">Two modules. One platform.</h1>
          <p className="text-slate-300 text-lg">
            Scrivera combines AI-powered clinical documentation with full healthcare operations management.
          </p>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
          {/* AI Medical Scribe */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100">
            <div className="inline-block bg-[#F0F9FF] text-[#0E7490] text-xs font-semibold px-3 py-1 rounded-full mb-4">
              Module 1
            </div>
            <h2 className="text-2xl font-bold text-[#0A2540] mb-2">AI Medical Scribe</h2>
            <p className="text-[#64748B] text-sm mb-6">
              Your doctors speak, Scrivera writes. Every consultation is captured, transcribed, and structured into clinical notes automatically.
            </p>
            <ul className="space-y-3">
              {scribeFeatures.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm text-[#0F172A]">
                  <span className="text-[#06B6D4] mt-0.5 flex-shrink-0">✓</span>
                  {f}
                </li>
              ))}
            </ul>
          </div>

          {/* Healthcare Operations AI */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100">
            <div className="inline-block bg-[#F0F9FF] text-[#0E7490] text-xs font-semibold px-3 py-1 rounded-full mb-4">
              Module 2
            </div>
            <h2 className="text-2xl font-bold text-[#0A2540] mb-2">Healthcare Operations AI</h2>
            <p className="text-[#64748B] text-sm mb-6">
              Run your facility more efficiently with an AI-assisted operations dashboard designed for busy clinical environments.
            </p>
            <ul className="space-y-3">
              {opsFeatures.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm text-[#0F172A]">
                  <span className="text-[#06B6D4] mt-0.5 flex-shrink-0">✓</span>
                  {f}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Built for African realities */}
      <section className="bg-[#0A2540] text-white py-16 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl font-bold mb-4">Built for African realities</h2>
          <p className="text-slate-300 mb-8 max-w-2xl mx-auto">
            We know connectivity can be unreliable, infrastructure varies, and your patients speak many languages. Scrivera is designed for this.
          </p>
          <div className="grid sm:grid-cols-3 gap-6 text-sm">
            <div className="bg-white/10 rounded-xl p-5">
              <div className="text-2xl mb-2">📶</div>
              <strong>Offline-capable</strong>
              <p className="text-slate-400 mt-1">Works without a reliable internet connection</p>
            </div>
            <div className="bg-white/10 rounded-xl p-5">
              <div className="text-2xl mb-2">🖥️</div>
              <strong>On-premise deployable</strong>
              <p className="text-slate-400 mt-1">Host on your own servers for full data sovereignty</p>
            </div>
            <div className="bg-white/10 rounded-xl p-5">
              <div className="text-2xl mb-2">🗣️</div>
              <strong>Multilingual</strong>
              <p className="text-slate-400 mt-1">English, Hausa, Yoruba, Igbo, Ikwerre, Twi, Ga, Ewe, Pidgin, French, and Swahili</p>
            </div>
          </div>
        </div>
      </section>

      <MarketingFooter />
    </div>
  );
}
